import React, { useEffect, useState, useRef } from "react";

import "./style.css";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Textfield from "../InviteUserModal/Textfield";
import ErrorText from "../commonComponents/ErrorTextContainer";
import { getWorkspaceForUser, getWorkspaces } from "../../utils/workspaces";
import { formatDateToHumanReadable } from "../../utils/utils";
import { CENTRALISED_BILLING_API } from "../../utils/envConfig";
const LIMIT = 24;

const normalizeCurrency = (currency?: string | null) => {
  return currency ? currency.toUpperCase() : "";
};

const getSubscriptionCurrency = (subscription?: any, customPayment?: any) => {
  const currency =
    subscription?.currency ||
    subscription?.activePlan?.currency ||
    subscription?.activePlan?.metadata?.currency ||
    customPayment?.currency;

  return normalizeCurrency(currency) || "-";
};

export default function Workspace() {
  const globalReducer = useSelector((store: any) => store.globalReducer);
  const navigate = useNavigate();
  const params = useParams();

  const [workspaceList, setWorkspaceList] = useState([]);
  const [searchStr, setSearchStr] = useState("");
  const [emailError, setEmailError] = useState("");
  const [totalWorkspaces, setTotalWorkspaces] = useState(0);
  const [subscriptionData, setSubscriptionData] = useState<{
    [key: string]: any;
  }>({});
  const [offset, setOffset] = useState(0);
  const [creditsData, setCreditsData] = useState<{ [key: string]: any }>({});
  const [customCreditsData, setCustomCreditsData] = useState<{
    [key: string]: any;
  }>({});

  const [customPaymentData, setCustomPaymentData] = useState({});

  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const lastFetchedPage = useRef(page);
  const isInitialSearch = useRef(true);

  useEffect(() => {
    // The user-id effect below performs the initial request. Without this guard
    // the empty search effect repeats the same request 600 ms later, doubling
    // all four downstream billing calls on slower renders.
    if (isInitialSearch.current) {
      isInitialSearch.current = false;
      return undefined;
    }
    const handler = setTimeout(() => {
      getAllWorkspaceData(0);
      setPage(1);
      setOffset(0);
    }, 600);

    return () => clearTimeout(handler);
  }, [searchStr]);

  useEffect(() => {
    getAllWorkspaceData(0);
  }, [params.userId]);

  // const getUserWorkspaceData = (offSetNum) => {
  //   console.log("getUserWorkspaceData");
  //   getWorkspaceForUser(params.userId, offSetNum).then(async (res) => {
  //     if (res.data) {
  //       setTotalWorkspaces(res.total);
  //       setTotalPage(Math.ceil(res.total / 24));
  //       setWorkspaceList(res.data);

  //       const workspaceIds = res.data.map((ws: any) => ws._id);
  //       const subscriptionUrl =
  //         "https://billing.test.streamoid.com/v1/subscriptions/current-new/" +
  //         workspaceIds.join(",");
  //       console.log("Subs URL: ", subscriptionUrl);

  //       const creditsUrl =
  //         "https://billing.test.streamoid.com/v1/credits/available-new/" +
  //         workspaceIds.join(",");
  //       console.log("Credits URL: ", creditsUrl);

  //       const response1 = await fetch(subscriptionUrl);
  //       const response2 = await fetch(creditsUrl);
  //       const subscriptionRes = await response1.json();
  //       const creditsData = await response2.json();

  //       if (response1.status === 200) {
  //         setSubscriptionData(
  //           subscriptionRes.data.reduce((acc, curr) => {
  //             acc[curr.workspaceId] = curr.subscription;
  //             return acc;
  //           }, {})
  //         );
  //       }

  //       if (response2.status === 200) {
  //         setCreditsData(
  //           creditsData.data.reduce((acc, curr) => {
  //             acc[curr.workspaceId] = curr.availableCredits;
  //             return acc;
  //           }, {})
  //         );
  //       }
  //     }
  //   });
  // };

  const getAllWorkspaceData = (offSetNum) => {
    console.log("getAllWorkspaceData");
    setIsLoading(true);

    getWorkspaces(offSetNum, searchStr, params.userId)
      .then(async (res) => {
        if (res.data && res.data.length) {
          setTotalWorkspaces(res.total);
          setTotalPage(Math.ceil(res.total / LIMIT));
          setWorkspaceList(res.data);
          const workspaceIds = res.data.map((ws: any) => ws._id);
          const subscriptionUrl =
            CENTRALISED_BILLING_API +
            "/subscriptions/current-new/" +
            workspaceIds.slice(0, LIMIT).join(",");
          console.log("Subs URL: ", subscriptionUrl);

          const creditsUrl =
            CENTRALISED_BILLING_API +
            "/credits/available-new/" +
            workspaceIds.slice(0, LIMIT).join(",");
          console.log("Credits URL: ", creditsUrl);

          const customUrl =
            CENTRALISED_BILLING_API +
            "/custom/total-credits" +
            "?workspaceIds=" +
            workspaceIds.slice(0, LIMIT).join(",");

          const customPaymnetUrl = CENTRALISED_BILLING_API + "/custom";

          const response1 = await fetch(subscriptionUrl);
          const response2 = await fetch(creditsUrl);
          const response3 = await fetch(customUrl);
          const response4 = await fetch(customPaymnetUrl);

          const subscriptionRes = await response1.json();
          const creditsData = await response2.json();
          const customCreditsData = await response3.json();
          const customPaymentData = await response4.json();

          if (response1.status === 200) {
            setSubscriptionData(
              subscriptionRes.data.reduce((acc, curr) => {
                acc[curr.workspaceId] = curr.subscription;
                return acc;
              }, {}),
            );
          }

          if (response2.status === 200) {
            setCreditsData(
              creditsData.data.reduce((acc, curr) => {
                acc[curr.workspaceId] = curr.availableCredits;
                return acc;
              }, {}),
            );
          }

          if (response3.status === 200) {
            setCustomCreditsData(customCreditsData.data);
          }

          if (response4.status === 200) {
            setCustomPaymentData(
              customPaymentData.data.reduce((acc, curr) => {
                acc[curr.workspaceId] = curr;
                return acc;
              }, {}),
            );
          }

          setIsLoading(false);
        } else {
          setTotalWorkspaces(res.total ?? 0);
          setTotalPage(Math.max(1, Math.ceil((res.total ?? 0) / LIMIT)));
          setWorkspaceList([]);
          setSubscriptionData({});
          setCreditsData({});
          setCustomCreditsData({});
          setCustomPaymentData({});
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOnClickNext = () => {
    if (page < totalPage) {
      setPage(page + 1);
      setOffset(offset + LIMIT);
      getAllWorkspaceData(offset + LIMIT);
    }
  };

  const handleOnClickPrev = () => {
    if (page > 1) {
      setPage(page - 1);
      setOffset(offset - LIMIT);
      getAllWorkspaceData(offset - LIMIT);
    }
  };

  const handleNavigateToBilling = (workspaceId: string) => {
    navigate(`/billing/${workspaceId}`);
  };

  const handleNavigateToBillingActivity = (workspaceId: string) => {
    navigate(`/activity/workspace/${workspaceId}`);
  };

  const handleNavigateToAccess = (workspaceId: string) => {
    navigate(`/access/${workspaceId}`);
  };

  const handleNavigateToRollOver = (workspaceId: string) => {
    navigate(`/roll-over/${workspaceId}`);
  };

  const handleNavigateToTrackUsage = (workspaceId: string) => {
    navigate(`/track-usage/${workspaceId}`);
  };

  let filteredWorkspaceData = workspaceList;

  return (
    <>
      <div className="box-border content-stretch flex flex-col gap-4 items-start justify-start relative size-full">
        {/* Header */}
        <div className="box-border content-stretch flex flex-row items-center justify-between p-0 relative shrink-0 w-full">
          <div className="box-border content-stretch flex flex-row gap-3 items-center justify-start p-0 relative shrink-0">
            <div className="flex flex-col font-['Geist:SemiBold',_sans-serif] font-semibold justify-center leading-[0] relative shrink-0 text-[#211f26] text-[24px] text-left text-nowrap tracking-[-0.24px]">
              <p className="adjustLetterSpacing leading-[30px] whitespace-pre font-semibold text-[18px]">
                Workspaces
              </p>
            </div>

            <div className="bg-[#cadfff] box-border content-stretch flex flex-row gap-2 items-center justify-center px-2 py-1 relative rounded-lg shrink-0">
              <div className="flex flex-col font-['Geist:Medium',_sans-serif] font-medium justify-center leading-[0] relative shrink-0 text-[#211f26] text-[12px] text-center text-nowrap">
                <p className="block leading-[16px] whitespace-pre">
                  {totalWorkspaces} workspace
                </p>
              </div>
            </div>
          </div>

          <div className="box-border content-stretch flex flex-row items-start justify-start p-0 relative shrink-0">
            <div className="font-['Geist:Medium',_sans-serif] font-medium leading-[0] relative shrink-0 text-[#fcfcfd] text-[14px] text-center text-nowrap">
              <Textfield
                label=""
                value={searchStr}
                onChange={(value) => setSearchStr(value)}
                placeholder="rick@desara.ai, chris@desara.ai, mika@desara.ai,..."
                type="email"
              />
              {emailError && <ErrorText hasError={emailError}></ErrorText>}
            </div>
          </div>
        </div>

        {/* Table */}
        {isLoading ? (
          <div
            style={{
              height: "400px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Loading...
          </div>
        ) : (
          <div
            className="bg-[rgba(253,252,253,0.6)] border border-[#EAE7EC] relative rounded-2xl shrink-0 w-full pb-3"
            style={{
              height: "calc(100vh - 140px)",
              overflowX: "auto",
              overflowY: "auto",
            }}
          >
            {filteredWorkspaceData && filteredWorkspaceData.length > 0 ? (
              <>
                <div
                  className="box-border content-stretch flex flex-col items-start justify-start p-0 relative min-w-full"
                  style={{ minWidth: "2305px" }}
                >
                  {/* Table Header */}
                  <div className="bg-[#f2eff3] h-10 relative shrink-0 w-full rounded-tr-[14px] rounded-tl-[14px]">
                    <div className="flex flex-row items-center overflow-clip relative size-full">
                      <div className="box-border content-stretch flex flex-row gap-5 h-10 items-center justify-start px-4 py-2 relative w-full">
                        <div className="box-border content-stretch flex flex-row gap-2 grow items-center justify-start min-h-px min-w-px p-0 relative shrink-0">
                          <div className="flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px] min-w-[180px]">
                              Workspace ID
                            </p>
                          </div>
                        </div>
                        <div className="box-border content-stretch flex flex-row gap-0.5 grow items-center justify-start p-0 relative shrink-0 w-40">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Name</p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[120px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">
                              Workspace Type
                            </p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[180px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Shop Domain</p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[70px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Currency</p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 grow items-center justify-start p-0 relative shrink-0 w-40">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">
                              Payment Status{" "}
                            </p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[88px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Plan</p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[130px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">
                              Available/Total Credits
                            </p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-40">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Added By</p>
                          </div>
                        </div>
                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[240px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Created At</p>
                          </div>
                        </div>
                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[88px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Action</p>
                          </div>
                        </div>

                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[125px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">
                              Billing Activity
                            </p>
                          </div>
                        </div>
                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[125px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Extra Access</p>
                          </div>
                        </div>
                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[110px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Roll Over</p>
                          </div>
                        </div>
                        <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[110px]">
                          <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#84828e] text-[12px] text-left">
                            <p className="block leading-[16px]">Track Usage</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="absolute border-[#eae7ec] border-[0px_0px_1px] border-solid inset-0 pointer-events-none" />
                  </div>

                  {/* Table Rows */}

                  {filteredWorkspaceData.map((workspace: any, index) => {
                    return (
                      <div
                        key={workspace._id}
                        className=" cursor-pointer box-border content-stretch flex flex-row gap-5 items-center justify-start px-0 py-1 relative shrink-0 w-full workspace-team-member-row"
                      >
                        <div className="absolute border-[#f0f0f0] border-[0px_0px_1px] border-solid inset-0 pointer-events-none" />
                        <div className="basis-0 grow min-h-px min-w-px relative shrink-0">
                          <div className="flex flex-row items-center relative size-full">
                            <div className="box-border content-stretch flex flex-row gap-5 items-center justify-start p-[16px] relative w-full">
                              {/* Email ID Column */}
                              <div className=" box-border content-stretch flex flex-row gap-2 grow items-center justify-start min-h-px min-w-px p-0 relative shrink-0">
                                <div className="flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell min-w-[180px]">
                                    {workspace._id}
                                  </p>
                                </div>
                              </div>

                              {/* Name Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center grow justify-start p-0 relative shrink-0 w-40">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {workspace.name || "-"}
                                  </p>
                                </div>
                              </div>

                              {/* Workspace Type Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[120px]">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {workspace.workspaceType || "-"}
                                  </p>
                                </div>
                              </div>

                              {/* Shop Domain Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[180px]">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {workspace.shopDomain || "-"}
                                  </p>
                                </div>
                              </div>

                              {/* Currency Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[70px]">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {getSubscriptionCurrency(
                                      subscriptionData[workspace._id],
                                      customPaymentData[workspace._id],
                                    )}
                                  </p>
                                </div>
                              </div>

                              {/* custom request Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center grow justify-start p-0 relative shrink-0 w-40">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {customPaymentData &&
                                    customPaymentData[workspace._id]
                                      ? `Pending Payment (${
                                          customPaymentData[workspace._id]
                                            ?.credits
                                        } creidts / ${
                                          customPaymentData[workspace._id].price
                                        } amount)`
                                      : "-"}
                                  </p>
                                </div>
                              </div>

                              {/* subscription Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[88px] ">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {subscriptionData[workspace._id]?.activePlan
                                      ?.name || "-"}
                                  </p>
                                </div>
                              </div>

                              {/* credits Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[130px]">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {creditsData[workspace._id]} /
                                    {customCreditsData &&
                                    customCreditsData[workspace._id]
                                      ? customCreditsData[workspace._id]
                                      : subscriptionData[workspace._id]
                                          ?.credits}
                                  </p>
                                </div>
                              </div>

                              {/* Added by Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-40">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {(workspace.addedBy &&
                                      workspace.addedBy.email) ||
                                      "-"}
                                  </p>
                                </div>
                              </div>

                              {/* Created At Column */}
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[240px]">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <p className="block leading-[18px] teams-table-cell">
                                    {formatDateToHumanReadable(
                                      workspace.createdAt,
                                      true,
                                      true,
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[88px] view-billing">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <button
                                    onClick={() => {
                                      handleNavigateToBilling(workspace._id);
                                    }}
                                  >
                                    View Billing
                                  </button>
                                </div>
                              </div>

                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[125px] view-billing">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <button
                                    onClick={() => {
                                      handleNavigateToBillingActivity(
                                        workspace._id,
                                      );
                                    }}
                                  >
                                    View Billing Activity
                                  </button>
                                </div>
                              </div>
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[125px] view-billing">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <button
                                    onClick={() => {
                                      handleNavigateToAccess(workspace._id);
                                    }}
                                  >
                                    Manage Access
                                  </button>
                                </div>
                              </div>
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[110px] view-billing">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <button
                                    onClick={() => {
                                      handleNavigateToRollOver(workspace._id);
                                    }}
                                  >
                                    View Roll Over
                                  </button>
                                </div>
                              </div>
                              <div className="box-border content-stretch flex flex-row gap-0.5 items-center justify-start p-0 relative shrink-0 w-[110px] view-billing">
                                <div className="basis-0 flex flex-col font-['Geist:Regular',_sans-serif] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
                                  <button
                                    onClick={() => {
                                      handleNavigateToTrackUsage(workspace._id);
                                    }}
                                  >
                                    Track Usage
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="nav-btns">
                  <div className="prev-btn" onClick={() => handleOnClickPrev()}>
                    Prev
                  </div>
                  <div>
                    Page{" "}
                    {
                      <input
                        value={page === 0 ? "" : page}
                        onChange={(e) => {
                          if (e.target.value === "") {
                            setPage(0);
                            return;
                          }
                          let val = Number(e.target.value);
                          if (isNaN(val) || val < 1) val = 1;
                          if (val > totalPage) val = totalPage;
                          setPage(val);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            const target = e.target as HTMLInputElement; // ✅ cast target
                            let val = Number(target.value);
                            if (target.value === "" || isNaN(val) || val < 1)
                              val = 1;
                            if (val > totalPage) val = totalPage;
                            setPage(val);
                            const newOffset = (val - 1) * 24;
                            setOffset(newOffset);
                            getAllWorkspaceData(newOffset);
                            lastFetchedPage.current = val;
                          }
                        }}
                        onBlur={(e) => {
                          if (e.target.value === "") {
                            setPage(lastFetchedPage.current);
                            return;
                          }
                          let val = Number(e.target.value);
                          if (isNaN(val) || val < 1) val = 1;
                          if (val > totalPage) val = totalPage;
                          if (val !== lastFetchedPage.current) {
                            setPage(val);
                            const newOffset = (val - 1) * 24;
                            setOffset(newOffset);
                            getAllWorkspaceData(newOffset);
                            lastFetchedPage.current = val;
                          }
                        }}
                        style={{
                          width: "24px",
                          height: "18px",
                          border: "1px solid gray",
                          padding: "4px",
                        }}
                      />
                    }{" "}
                    /{totalPage}
                  </div>
                  <div className="next-btn" onClick={() => handleOnClickNext()}>
                    Next
                  </div>
                </div>
              </>
            ) : (
              <div
                style={{
                  height: "400px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                No user to show
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
